"use client";

import { SubscriptionStatus } from "@prisma/client";
import { useAuthUser } from "@/app/(components)/specifics/wrappers/AuthProvider/AuthProvider";
import { useCanRunPaidActions } from "@/app/(components)/specifics/wrappers/BrandProvider/BrandProvider";
import { useFetchSubscription } from "@/app/hooks/fetchs/credits/useFetchSubscription";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { DashboardCounters as Counters } from "@/app/types/dashboard/DashboardCounters";
import { UWallet } from "@/app/utils/UWallet";
import styles from "./Dashboard.module.css";
import DashboardStat from "./DashboardStat";

type Props = {
  counters: Counters;
  foundProspects: number;
};

export default function DashboardCounters(props: Props) {
  const T = useT();
  const { counters, foundProspects } = props;

  const user = useAuthUser();
  const canRunPaidActions = useCanRunPaidActions();
  const { data: overview } = useFetchSubscription({ enabled: !!user && canRunPaidActions });

  const status = overview?.subscription?.status;
  const hasPlan = status === SubscriptionStatus.TRIALING || status === SubscriptionStatus.ACTIVE;
  const plan = overview?.plan;
  const hours = user ? UWallet.spendableHours(user, hasPlan) : 0;
  const usedHours = user && plan && hasPlan ? UWallet.usedCallHours(user, plan) : 0;

  return (
    <div className={styles.counters}>
      <DashboardStat
        label={T(TKey.DASHBOARD_COUNTER_ANALYSED_CALLS) as string}
        value={counters.analysedCalls}
        total={counters.totalCalls}
      />

      <DashboardStat
        label={T(TKey.DASHBOARD_COUNTER_QUALIFIED_PROSPECTS) as string}
        value={counters.qualifiedProspects}
        total={foundProspects || undefined}
      />

      {canRunPaidActions && (
        <DashboardStat
          label={T(TKey.DASHBOARD_COUNTER_CALL_HOURS) as string}
          value={hours}
          total={usedHours + hours || undefined}
        />
      )}
    </div>
  );
}
